import React from 'react'
import { connect } from 'react-redux'

import PropTypes from 'prop-types'
import BaseComponent from 'utils/BaseComponent'
import Button from 'components/Button'
import Input from 'components/Input'

import './styles.scss'

export class ConfirmationPhraseModal extends BaseComponent {

  // Delegate method should be set to _onAccept() on props when the objected is created
  // Exameple: 
  // <ConfirmationPhraseModal _onAccept={this._delegateAcceptAction.bind(this)} match={this.props.match} />

  constructor(props) {
    super(props)
    this.state = {
      confirmKey: '',
      buttonProps: {
        disabled: true
      },
      errors: {}
    }
    this._bind('_handleSubmit', '_cancelAction', '_onChange', '_renderMessage')
  }

  componentDidMount() {
    
  }

  _handleSubmit(e) {
    e.preventDefault()
    this.props._onAccept()
    var hideModal = this.props.hideModal
    if (hideModal == null || hideModal){
      this.context.toggleModal(false)
    }
  }

  _cancelAction(e){
    this.context.toggleModal(false)
  }

  _onChange(evt) {
    const confirmKey = (evt.target.value).toUpperCase()
    var phrase = this.props.phrase || 'CONFIRMAR'
    const buttonProps = confirmKey === phrase ? {} : {disabled: true}
    this.setState({ confirmKey, buttonProps })
  }


  _renderMessage(){
    var phrase = this.props.phrase || 'CONFIRMAR'
    return !!this.props.message ? (
      <div className="content">
        <br></br>
        <p>{ this.props.message }</p>
        <p>Escribe "<b>{ phrase }</b>" para confirmar.</p>
        <Input
            placeholder={phrase}
            name="confirmKey"
            onChange={this._onChange}
            value={this.state.confirmKey}
          />
      </div>
    ) : null 
  }

  render() {
    var title = this.props.title || "Confirmar"
    var acceptLabel = this.props.acceptLabel || "Aceptar"
    var cancelLabel = this.props.cancelLabel || "Cancelar"
    return(
      <div id="ConfirmationModal" className="ConfirmationModal Modal__content">
        <div className="EditModal__header d-flex justify-content-between align-items-center">
          <h1>{ title }</h1>
          <span className="material-icons close-button" onClick={this._cancelAction}>clear</span>
        </div>
        <form onSubmit={this._handleSubmit} className="f-flex EditModal__form">
            { this._renderMessage() }
            <div className="controls d-flex justify-content-between">
              <Button className="button"
                    size="small"
                    buttonType="danger"
                    {...this.state.buttonProps}>{ acceptLabel }</Button>
              <Button className="button"
                    size="small"
                    buttonType="primary"
                    type="button"
                    onClick={this._cancelAction}>{cancelLabel}</Button>
            </div>
        </form>
      </div>
    )
  }
}

ConfirmationPhraseModal.contextTypes = {
  toggleModal: PropTypes.func.isRequired,
  secondToggleModal: PropTypes.func.isRequired
}


const mapStateToProps = (state) => {
  return {
    state: state.clientDetail.get('state').toObject(),
    location: state.clientDetail.get('location').toObject(),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationPhraseModal)



// WEBPACK FOOTER //
// ./src/components/ConfirmationPhraseModal/index.js